export const articles = [
  {
    id: 1,
    readingTime: 10,
    name: 'Les Thrulkhors – Qu’est ce que c’est ?',
    text: '',
    tags: ['Thrulkhors', 'Tradition', 'Yoga tibétain'],
    src: '/img/thrulkhor-01.webp',
    link: '/articles/1',
    classes: ['article-card-adjust-01'],
  },
  {
    id: 2,
    readingTime: 7,
    name: 'Thrulkhors et corps subtil',
    // text: 'La tradition au coeur du yoga',
    tags: ['Thrulkhors', 'Yoga tibétain', 'Corps subtil'],
    src: '/img/coprs-subtil.jpg',
  },
];
